export default {
  sidebar: {
    controlPanel: 'Panel de Control',
    reports: 'Reportes',
    ClassAttendance: 'Asistencia Clase',
    ClassExternalAttendance: 'Asistencia Clase Externa',
    StudentAttendance: 'Asistencia Estudiantes',
    StudentBonusAttendance: 'Asistencia Estudiantes Bonus ',
  },
  dashboard: {
    welcomeHeading: '¡Bienvenido {role}!',
    inProgressSubjects: 'Asignaturas en Curso',
    pastSubjects: { alumno: 'Asignaturas Tomadas', profesor: 'Asignaturas Dictadas' },
  },
  reports: {
    filters: {
      week: 'semana',
      month: 'mes',
      quarter: 'trimestre',
    },
  },
}
